import { NotificationTypes } from "../../../enums/notificationTypes";

const { ERROR } = NotificationTypes;

export const UPLOAD_NOTIFICATION_CONSTANTS = {
  CAMERA_ACCESS_DENIED: {
    type: ERROR,
    message: "Camera Access Denied",
    description:
      "Please enable camera permission in your browser settings and reload the page.",
  },
};
